<script setup>
import { ref, onMounted, computed, nextTick } from "vue";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useQuizStore } from "@/stores/storeQuiz";
import { useModals } from "@/utils/useModals";
import { sendMetrik } from '@/utils/metrika'
import { sendAdriver } from '@/utils/metrika';
import QuizFillWords from "@/components/quize/QuizFillWords.vue";
import QuizEndGameFillWords from "@/components/quize/QuizEndGameFillWords.vue";
import QuizWelcomeScreen from "@/components/quize/QuizWelcomeScreen.vue";
import { set } from "browser-cookies";


const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const storeQuiz = useQuizStore();
const { openModal } = useModals();


onMounted( async() => {
	
	
});
</script>
<template>
	<section class="quiz"  :style="{ paddingTop: storeScroll.paddingTop }">
		<TransitionGroup>

			<QuizWelcomeScreen v-if="storeQuiz.isShowWelcomScreen" class="--words">				
				<template #nameGame>Арт-Филворд</template>
				<template #descGame>
					<p class="quiz__text">Приготовьтесь проверить свою внимательность! <br>
						Найдите слова, спрятанные в сетке букв — все они связаны с русским искусством, известными картинами, художниками и  крупами!
					</p>
				</template>
				<template #listGame>
					<ul>
						<li>1. Соединяйте буквы в слова о картинах, художниках и продуктах Мистраль: просто выберите первую и последнюю букву слова по горизонтали или вертикали — и оно засчитается</li>
						<li>2. Находите все слова в отведенное на игру время (3 минуты)</li>
					</ul>
				</template>
				<template #rulesGame>
					<p>
						Найдите все слова, получайте шанс стать обладателем эксклюзивных призов. <br> 
						Полагайтесь на свою внимательность, демонстрируйте знания и стремитесь к победе! <br>
						Готовы? Нажимайте <span>«СТАРТ»</span>
					</p>
				</template>
				<template #btnStartGame>
					<button @click="storeQuiz.startGame(), sendMetrik('reachGoal', 'Fillword_start')" class="btn --blue">Старт</button>
				</template>
			</QuizWelcomeScreen>

			<QuizFillWords v-if="storeQuiz.isShowGame" />

			<QuizEndGameFillWords v-if="storeQuiz.isShowEndGame" />
			
		</TransitionGroup>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz {
	background-image: url("@/assets/img/main/main_bg.webp");
	background-repeat: no-repeat;
	background-position: center; /* x y*/
	background-size: cover; /* w h*/
	@media (max-width: vars.$xx) {
		background-image: url("@/assets/img/main/main_bg_mobile.webp");
	}
}
.v-enter-active,
.v-leave-active {
	transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(10px);
}
</style>
